import React from "react";
import { NumericFormat } from "react-number-format";

interface IProps {
  value?: number | string;
  [key: string]: any;
}

const DniText: React.FC<IProps> = ({ value = "", ...otherProps }) => {
  return (
    <NumericFormat
      id="dni"
      displayType={"text"}
      value={value}
      valueIsNumericString
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={0}
      {...otherProps}
    />
  );
};

export default DniText;
